import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { useViewAs } from '../context/ViewAsContext';
import {
  canAccessOwnerRoutes,
  isGuestContext,
  resolveEffectiveRole,
  showsAdminNavigation,
  showsOwnerNavigation,
} from '../lib/roleContext';
import {
  canAccessClientDashboard,
  isPureClientAccount,
  showsClientHeaderQuickLinks,
  showsOwnerDashboardNav,
} from '../lib/roleExperience';
import {
  canAccessOwnerPricingLane,
  shouldUseClientPremiumPricingLane,
} from '../lib/pricingLaneDisplay';

export function useRoleContext() {
  const { user, isAdmin, sessionRevision } = useAuth();
  const { viewAsRole } = useViewAs();

  return useMemo(() => {
    const effectiveRole = resolveEffectiveRole({ user, isAdmin, viewAsRole });
    const guestCtx = isGuestContext({ user, isAdmin, viewAsRole });
    const roleState = { user, isAdmin, viewAsRole };
    return {
      user,
      isAdmin,
      viewAsRole,
      effectiveRole,
      sessionRevision,
      canAccessOwner: canAccessOwnerRoutes(roleState),
      isGuestContext: guestCtx,
      showsOwnerNav: showsOwnerNavigation(roleState),
      showsAdminNav: showsAdminNavigation(roleState),
      showsClientHeaderQuickLinks: showsClientHeaderQuickLinks({ ...roleState, isGuestContext: guestCtx }),
      canAccessClientDashboard: canAccessClientDashboard(roleState),
      isPureClientAccount: isPureClientAccount(roleState),
      canAccessOwnerPricingLane: canAccessOwnerPricingLane(roleState),
      shouldUseClientPremiumPricingLane: shouldUseClientPremiumPricingLane(roleState),
      showsOwnerDashboardNav: showsOwnerDashboardNav({
        canAccessOwner: canAccessOwnerRoutes(roleState),
        isGuestContext: guestCtx,
      }),
    };
  }, [user, isAdmin, viewAsRole, sessionRevision]);
}
